import { render, staticRenderFns } from "./SubscribeForm2026PlanHeader.vue?vue&type=template&id=961b50b2&scoped=true&"
import script from "./SubscribeForm2026PlanHeader.vue?vue&type=script&lang=js&"
export * from "./SubscribeForm2026PlanHeader.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeForm2026PlanHeader.vue?vue&type=style&index=0&id=961b50b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961b50b2",
  null
  
)

export default component.exports